exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty-list {\n  display: flex;\n  align-items: center; }\n  .empty-list h1 {\n    margin-bottom: 2px; }\n  .empty-list svg {\n    fill: #e9b949;\n    margin-right: 20px; }\n", ""]);

// exports
